/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { SddcProvidersEnum } from './sddcProvidersEnum';


export interface OperatorVcdsDeploymentCloudProvider { 
    provider?: CloudProviderEnum;
    /**
     * Availability zone
     */
    availability_zone?: string;
    sddc_providers?: Array<SddcProvidersEnum>;
    /**
     * Region
     */
    region?: string;
    /**
     * Provider cloud account id
     */
    account_id?: string;
}
export namespace OperatorVcdsDeploymentCloudProvider {
}


